import { Navigate, useLocation, useParams } from "react-router-dom";

const ENG_BASE = {
  construction: "/construction-projects",
  maintenance: "/maintain-projects",
  emergency: "/emergency-projects",
};

/**
 * رابط ثابت لأمر العمل (/work-order/:id?type=…&event=…) يُستخدم في البريد والإشعارات،
 * ويُوجَّه إلى صفحة تفاصيل أمر العمل الموحدة لنوعه. الصفحة نفسها تتحقق من الصلاحية.
 */
export default function WorkOrderLink({ userType }) {
  const { id } = useParams();
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const type = (params.get("type") || "construction").toLowerCase();
  params.delete("type");
  const rest = params.toString() ? `?${params.toString()}` : "";
  const base = ["eng", "contractor"].includes(userType) ? ENG_BASE[type] || (type === "construction" ? ENG_BASE.construction : `/project/${type}`) : `/project/${type}`;
  return <Navigate to={`${base}/${id}${rest}`} replace />;
}

/** مسار أمر العمل لإشعار الإشارة في سجل الأحداث، أو null لبقية الإشعارات. */
export function eventLinkFor(notification) {
  // تحديث 102 — إشعار التوجيه (واحد لكل مستلم لعدة أوامر) → تفاصيل التوجيه بأوامر المستلم
  if (String(notification?.projectType || "").toLowerCase() === "directive" && notification?.projectId) return `/directives?tab=mine&batch=${notification.projectId}`;
  if (!notification?.workOrderEventId || !notification?.projectId) return null;
  const type = String(notification.projectType || "construction").toLowerCase();
  // كل الأنواع غير الإنشاءات تحمل نوعها (الصيانة والطوارئ وأعمال التأهيل والمشاريع الخاصة)
  const t = type !== "construction" ? `&type=${type}` : "";
  return `/work-order/${notification.projectId}?event=${notification.workOrderEventId}${t}`;
}
